"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalVideoControllerState = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const rxjs_2 = require("./rxjs");
function useLocalVideoControllerState(localVideoController) {
    const localVideoControllerState = localVideoController.pipe((0, operators_1.switchMap)(controller => !controller
        ? (0, rxjs_1.of)({
            enabled: false,
            connected: false,
            started: false,
        })
        : (0, rxjs_1.combineLatest)([
            controller.enabled,
            controller.connected,
            controller.started,
        ]).pipe((0, operators_1.map)(([enabled, connected, started]) => ({ enabled, connected, started })))));
    return (0, rxjs_2.useObservable)(localVideoControllerState);
}
exports.useLocalVideoControllerState = useLocalVideoControllerState;
//# sourceMappingURL=use_local_video_controller_state.js.map